/* eslint-disable */
// @ts-nocheck
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unknown-property */
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/no-unresolved */
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars, react/jsx-newline, react/jsx-no-bind, no-else-return */
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps, @typescript-eslint/no-use-before-define, no-lonely-if, no-nested-ternary, import/no-extraneous-dependencies */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
/* eslint-disable one-var, prefer-destructuring, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Tag, Button, Space, Typography, Card, Tooltip, Modal, Form, Input, Select, message } from 'antd';
import { ReloadOutlined, CheckCircleTwoTone, CloseCircleTwoTone, RollbackOutlined, FileSearchOutlined, PlusOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { DatePicker } from '@material-ui/pickers';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { settlementAPI } from '../../services/api';
import SettlementWizard from '../SettlementWizard/SettlementWizard';
import SettlementViewModal from '../SettlementViewModal/SettlementViewModal';
import './SettlementsTable.css';
import BusinessIcon from '@mui/icons-material/Business';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
import BlurCircularIcon from '@mui/icons-material/BlurCircular';
import SearchIcon from '@mui/icons-material/Search';
import cookies from 'js-cookie'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';

import { CircularProgress } from '@material-ui/core';
import { Table as MuiTable, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
// Reuse shared table styles used in Merchant POS for consistent look & feel
import 'app/cards-management/style.css';
import { useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
const { Text, Title } = Typography;

const statusColors = {
  Draft: 'default',
  Confirmed: 'processing',
  Cleared: 'success',
  Reversed: 'error'
};

// Status options will be defined inside component to access intl

const SettlementsTable = () => {
  const intl = useIntl();
  const hasWriteAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'SettlementTransactions')
  );
  const statusOptions = [
    { label: intl.formatMessage({ id: 'settlement_All' }), value: '' },
    { label: intl.formatMessage({ id: 'settlement_Draft' }), value: 'Draft' },
    { label: intl.formatMessage({ id: 'settlement_Confirmed' }), value: 'Confirmed' },
    { label: intl.formatMessage({ id: 'settlement_Cleared' }), value: 'Cleared' },
    { label: intl.formatMessage({ id: 'settlement_Reversed' }), value: 'Reversed' },
  ];

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [filters, setFilters] = useState({ status: '', search: '' });
  const [searchQuery, setSearchQuery] = useState('');
  const [wizardVisible, setWizardVisible] = useState(false);
  const [initialDraft, setInitialDraft] = useState(null);

  const [clearModal, setClearModal] = useState({ visible: false, id: null });
  const [reverseModal, setReverseModal] = useState({ visible: false, id: null });
  const [clearForm] = Form.useForm();
  const [reverseForm] = Form.useForm();
  const [viewModal, setViewModal] = useState({ visible: false, record: null });

  // Get current language for RTL support
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
  const isArabic = currentLanguageCode === 'ar-eg';

  // Helper functions to get localized names based on current language
  const getSenderName = (record) => {
    if (isArabic && record.sender_name_ar) {
      return record.sender_name_ar;
    }
    return record.sender_name || '-';
  };

  const getBeneficiaryName = (record) => {
    if (isArabic && record.beneficiary_name_ar) {
      return record.beneficiary_name_ar;
    }
    return record.beneficiary_name || '-';
  };

  const getSettlementTypeName = (record) => {
    if (isArabic && record.settlement_type_name_ar) {
      return record.settlement_type_name_ar;
    }
    return record.settlement_type_name || '-';
  };

  // Initialize form with default values when modal opens
  useEffect(() => {
    if (clearModal.visible) {
      clearForm.setFieldsValue({
        bank_transfer_date: moment(),
        bank_description: intl.formatMessage({ id: 'settlement_NoDescriptionEntered' })
      });
    }
  }, [clearModal.visible, clearForm, intl]);


  // Function to translate status values
  const translateStatus = (status) => {
    const statusTranslations = {
      'Draft': intl.formatMessage({ id: 'settlement_StatusDraft' }),
      'Confirmed': intl.formatMessage({ id: 'settlement_StatusConfirmed' }),
      'Cleared': intl.formatMessage({ id: 'settlement_StatusCleared' }),
      'Reversed': intl.formatMessage({ id: 'settlement_StatusReversed' })
    };
    return statusTranslations[status] || status;
  };

  const fetchData = useCallback(async (page = 1, pageSize = 10, extra = {}) => {
    try {
      setLoading(true);
      const params = {
        page,
        limit: pageSize,
        ...filters,
        ...extra
      };
      // Remove empty filters
      Object.keys(params).forEach(k => { if (params[k] === '' || params[k] == null) delete params[k]; });
      const res = await settlementAPI.list(params);
      const items = res?.data?.data?.items || [];
      const total = res?.data?.data?.total || 0;
      setData(items);
      setPagination({ current: page, pageSize, total });
    } catch (e) {
      message.error(intl.formatMessage({ id: 'settlement_FailedToLoad' }));
    } finally {
      setLoading(false);
    }
  }, [filters]);

  // Pagination handlers
  const handlePrevious = () => {
    if (pagination.current > 1) {
      const newPage = pagination.current - 1;
      setPagination(prev => ({ ...prev, current: newPage }));
      fetchData(newPage, pagination.pageSize);
    }
  };

  const handleNext = () => {
    const pageCount = Math.ceil((pagination.total || 0) / pagination.pageSize);
    if (pagination.current < pageCount) {
      const newPage = pagination.current + 1;
      setPagination(prev => ({ ...prev, current: newPage }));
      fetchData(newPage, pagination.pageSize);
    }
  };

  useEffect(() => {
    fetchData(pagination.current, pagination.pageSize);
  }, [fetchData, pagination.current, pagination.pageSize]);

  const columns = useMemo(() => ([
    {
      title: intl.formatMessage({ id: 'settlement_Date' }),
      dataIndex: 'created_at',
      key: 'created_at',
      width: 120,
      render: (value) => {
        try {
          return value ? moment(value).format('DD-MM-YYYY') : '-';
        } catch (error) {
          console.warn('Date formatting error:', error, value);
          return value || '-';
        }
      }
    },

    {
      title: intl.formatMessage({ id: 'settlement_Sender' }),
      dataIndex: 'sender_name',
      key: 'sender_name',
      width: 180,
      render: (v, record) => getSenderName(record)
    },
    {
      title: intl.formatMessage({ id: 'settlement_Beneficiary' }),
      dataIndex: 'beneficiary_name',
      key: 'beneficiary_name',
      width: 180,
      render: (v, record) => getBeneficiaryName(record)
    },
    {
      title: intl.formatMessage({ id: 'settlement_Type' }),
      dataIndex: 'settlement_type_name',
      key: 'settlement_type_name',
      width: 160,
      render: (v, record) => getSettlementTypeName(record)
    },
    {
      title: intl.formatMessage({ id: 'settlement_Period' }),
      key: 'period',
      width: 200,
      render: (_, r) => {
        let fromDate, toDate;
        try {
          fromDate = r.settlement_from_date ? moment(r.settlement_from_date).format('DD-MM-YYYY') : '-';
          toDate = r.settlement_till_date ? moment(r.settlement_till_date).format('DD-MM-YYYY') : '-';
        } catch (error) {
          console.warn('Date formatting error in period:', error, r);
          fromDate = r.settlement_from_date || '-';
          toDate = r.settlement_till_date || '-';
        }

        return (
          <div
            className="period-cell"
            style={{
              direction: 'ltr',
              display: 'flex',
              alignItems: 'center',
              justifyContent: isArabic ? 'flex-end' : 'flex-start',
              gap: '8px',
              whiteSpace: 'nowrap'
            }}
          >
            {isArabic ? (
              <>
                <span className="date-to">{toDate}</span>
                <span className="date-separator" style={{ color: '#666', fontSize: '14px' }}> - </span>
                <span className="date-from">{fromDate}</span>
              </>
            ) : (
              <>
                <span className="date-from">{fromDate}</span>
                <span className="date-separator" style={{ color: '#666', fontSize: '14px' }}>–</span>
                <span className="date-to">{toDate}</span>
              </>
            )}
          </div>
        );
      }
    },
    {
      title: intl.formatMessage({ id: 'settlement_Amount' }),
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      width: 130,
      render: (v) => `${Number(v || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${intl.formatMessage({ id: 'settlement_EGP' })}`
    },
    {
      title: intl.formatMessage({ id: 'settlement_Status' }),
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (value) => <Tag color={statusColors[value] || 'default'}>{translateStatus(value)}</Tag>
    },
    {
      title: intl.formatMessage({ id: 'settlement_Actions' }),
      key: 'actions',
      fixed: 'right',
      width: 180,
      render: (_, record) => {
        const id = record.id;
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <Space>
              {record.status === 'Draft' && (
                <Tooltip title={intl.formatMessage({ id: 'settlement_ContinueAndConfirm' })}>
                  <Button size="small" type="primary" icon={<CheckCircleOutlined />} onClick={(e) => { e.stopPropagation(); setInitialDraft(record); setWizardVisible(true); }}>
                    {intl.formatMessage({ id: 'settlement_Continue' })}
                  </Button>
                </Tooltip>
              )}
              {record.status === 'Confirmed' && (
                <>
                  <Tooltip title={intl.formatMessage({ id: 'settlement_ClearSettlement' })}>
                    <Button size="small" danger onClick={(e) => { e.stopPropagation(); setClearModal({ visible: true, id }); }}>
                      {intl.formatMessage({ id: 'settlement_Clear' })}
                    </Button>
                  </Tooltip>
                  <Tooltip title={intl.formatMessage({ id: 'settlement_ReverseSettlement' })}>
                    <Button size="small" icon={<RollbackOutlined />} onClick={(e) => { e.stopPropagation(); setReverseModal({ visible: true, id }); }}>
                      {intl.formatMessage({ id: 'settlement_Reverse' })}
                    </Button>
                  </Tooltip>
                </>
              )}
              {record.status === 'Cleared' && (
                <Tooltip title={intl.formatMessage({ id: 'settlement_SettlementIsCleared' })}>
                  <Text type="secondary">{intl.formatMessage({ id: 'settlement_Cleared' })}</Text>
                </Tooltip>
              )}
            </Space>
          </div>
        );
      }
    }
  ]), [filters, intl]);

  const handleTableChange = (paginationConfig) => {
    fetchData(paginationConfig.current, paginationConfig.pageSize);
  };

  return (
    <div className="settlements-wrapper">
      <h3 className='header-of-subsystem-page' style={{ marginTop: "-10px", fontSize: "24px" }}>
        <BusinessIcon style={{ margin: "10px  10px 13px 10px", fontSize: "29px" }} />
        {intl.formatMessage({ id: 'SettlementTransactions' })}

        {/* Add new settlement button styled like merchant */}
        {hasWriteAccess && <button
          className='styleAddBtn'
          style={isArabic ? { left: '90px', fontSize: "13px", marginTop: "10px" } : { right: '90px', fontSize: "13px", marginTop: "10px" }}
          onClick={() => { setInitialDraft(null); setWizardVisible(true); }}
        >
          {intl.formatMessage({ id: 'settlement_NewSettlement' })}
        </button>}
      </h3>


      {/* Controller section styled like merchantPOSTable */}
      <div className='table-controller-sec' >
        <div style={{ display: 'flex', marginTop: 0, marginBottom: 0 }}>

          {/* Search */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setFilters(prev => ({ ...prev, search: searchQuery || '' }));
              fetchData(1, pagination.pageSize, { search: searchQuery || '' });
              setPagination(prev => ({ ...prev, current: 1 }));
            }}
            className="input-search"

          >
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder={intl.formatMessage({ id: 'settlement_SearchPlaceholder' })}
              style={{ width: "310px" }}
            />
            <button style={
              currentLanguageCode == "en-us" ?
                { right: "8px" } : { left: "8px" }

            }
              type="submit"
            >

              <SearchIcon style={{ fontSize: "22px" }} />
            </button>
          </form>
          {filters.search && (
            <button
              className="cancelBtnStyle"
              style={{ marginTop: 0, marginBottom: 15 }}
              onClick={() => {
                setSearchQuery('');
                setFilters(prev => ({ ...prev, search: '' }));
                fetchData(1, pagination.pageSize, { search: '' });
                setPagination(prev => ({ ...prev, current: 1 }));
              }}
            >
              {intl.formatMessage({ id: 'Cancel' })}
            </button>
          )}
        </div>

        {/* Right side controls: status filter, page info, navigation, page size */}
        <div style={{ direction: 'ltr' }}>
          <span style={{ margin: '10px' }}>
            <bdi>
              {/*<span className='show-span' style={{ margin: '10px' }}>
                  <bdi>{intl.formatMessage({ id: 'status' })}</bdi>
                </span>*/}
              <select
                className='show-select'
                style={{ direction: 'ltr' }}
                value={filters.status}
                onChange={(e) => {
                  const v = e.target.value;
                  setFilters(prev => ({ ...prev, status: v }));
                  setPagination(prev => ({ ...prev, current: 1 }));
                  fetchData(1, pagination.pageSize, { status: v });
                }}
              >
                {statusOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </bdi>
          </span>

          {data?.length > 0 && (
            <>
              {isArabic ? (
                <span style={{ margin: '10px', direction: 'ltr' }}>
                  {Math.ceil((pagination.total || 0) / pagination.pageSize)}
                  <span className='show-span'>
                    <bdi style={{ margin: '10px' }}>{intl.formatMessage({ id: 'From' })}</bdi>
                  </span>
                  {pagination.current}
                </span>
              ) : (
                <span style={{ margin: '10px', direction: 'ltr' }}>
                  {pagination.current}
                  <span className='show-span'>
                    <bdi style={{ margin: '10px' }}>{intl.formatMessage({ id: 'From' })}</bdi>
                  </span>
                  {Math.ceil((pagination.total || 0) / pagination.pageSize)}
                </span>
              )}
            </>
          )}

          {data?.length > 0 && (
            <>
              <button
                className='page-navigation-arrow'
                disabled={currentLanguageCode == "en-us" ? pagination.current === 1 : pagination.current >= Math.ceil((pagination.total || 0) / pagination.pageSize)}
                onClick={currentLanguageCode == "en-us" ? handlePrevious : handleNext}
              >
                <span style={{ direction: "ltr" }}>
                  <KeyboardArrowLeftIcon style={{ fontSize: "30px" }} />
                </span>
              </button>
              <bdi>
                {((pagination.current - 1) * pagination.pageSize) + 1}
                {' - '}
                {Math.min(pagination.current * pagination.pageSize, pagination.total)} {intl.formatMessage({ id: 'Of' })} {pagination.total}
              </bdi>
              <button
                className='page-navigation-arrow'
                disabled={currentLanguageCode == "en-us" ? pagination.current >= Math.ceil((pagination.total || 0) / pagination.pageSize) : pagination.current === 1}
                onClick={currentLanguageCode == "en-us" ? handleNext : handlePrevious}
              >
                <span style={{ direction: "ltr" }}>
                  <KeyboardArrowRightIcon style={{ fontSize: "30px" }} />
                </span>
              </button>
            </>
          )}

          <span style={{ margin: '10px' }}>
            <bdi>
              <span className='show-span' style={{ margin: '10px' }}>
                {intl.formatMessage({ id: 'Show' })}
              </span>
              <select
                className='show-select'
                value={pagination.pageSize}
                onChange={(e) => {
                  const newSize = Number(e.target.value);
                  setPagination(prev => ({ ...prev, pageSize: newSize, current: 1 }));
                  fetchData(1, newSize);
                }}
              >
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </bdi>
          </span>
        </div>






        {/* MUI Table implementation */}
        <div className="Table-Wrapper" style={{ border: "0", width: "100%", borderRadius: "10px" }}>
          <MuiTable size="small" aria-label="settlements table" style={{ border: "1px solid lightgray", width: "100%", borderRadius: "10px" }}>
            <TableHead >
              <TableRow>
                <TableCell align="left">{intl.formatMessage({ id: 'settlement_Date' })}</TableCell>
                <TableCell align="center">{intl.formatMessage({ id: 'settlement_Sender' })}</TableCell>
                <TableCell align="center">{intl.formatMessage({ id: 'settlement_Beneficiary' })}</TableCell>
                <TableCell align="center">{intl.formatMessage({ id: 'settlement_Type' })}</TableCell>
                <TableCell align="center">{intl.formatMessage({ id: 'settlement_Period' })}</TableCell>
                <TableCell align="right">{intl.formatMessage({ id: 'settlement_Amount' })}</TableCell>
                <TableCell align="center">{intl.formatMessage({ id: 'settlement_Status' })}</TableCell>
                <TableCell align="center">{intl.formatMessage({ id: 'settlement_Actions' })}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <div style={{ padding: 12 }}><CircularProgress style={{ width: 40, height: 40 }} /></div>
                  </TableCell>
                </TableRow>
              ) : (data && data.length > 0 ? (
                data.map((record) => {
                  const id = record.id;
                  let fromDate, toDate;
                  try {
                    fromDate = record.settlement_from_date ? moment(record.settlement_from_date).format('DD-MM-YYYY') : '-';
                    toDate = record.settlement_till_date ? moment(record.settlement_till_date).format('DD-MM-YYYY') : '-';
                  } catch (error) {
                    console.warn('Date formatting error in mobile view:', error, record);
                    fromDate = record.settlement_from_date || '-';
                    toDate = record.settlement_till_date || '-';
                  }
                  return (
                    <TableRow key={id} hover style={{ cursor: 'pointer' }} onClick={() => setViewModal({ visible: true, record })}>
                      <TableCell align="left">{
                        (() => {
                          try {
                            return record.created_at ? moment(record.created_at).format('DD-MM-YYYY') : '-';
                          } catch (error) {
                            console.warn('Date formatting error in created_at:', error, record.created_at);
                            return record.created_at || '-';
                          }
                        })()
                      }</TableCell>
                      <TableCell align="center">{getSenderName(record)}</TableCell>
                      <TableCell align="center">{getBeneficiaryName(record)}</TableCell>
                      <TableCell align="center">{getSettlementTypeName(record)}</TableCell>
                      <TableCell align="center">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, whiteSpace: 'nowrap', marginTop: '0' }}>
                          {isArabic ? (<>
                            <span className="date-to">{toDate}</span>
                            <span className="date-separator" style={{ color: '#666', fontSize: 14 }}> - </span>
                            <span className="date-from">{fromDate}</span>
                          </>) : (<>
                            <span className="date-from">{fromDate}</span>
                            <span className="date-separator" style={{ color: '#666', fontSize: 14 }}>–</span>
                            <span className="date-to">{toDate}</span>
                          </>)}
                        </div>
                      </TableCell>
                      <TableCell align="right">{`${Number(record.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${intl.formatMessage({ id: 'settlement_EGP' })}`}</TableCell>
                      <TableCell align="center">
                        <span
                          style={{
                            display: 'inline-block',
                            padding: '2px 10px',
                            borderRadius: 12,
                            fontSize: 12,
                            fontWeight: 600,
                            color: (
                              record.status === 'Cleared' ? '#389e0d' :
                                record.status === 'Confirmed' ? '#1677ff' :
                                  record.status === 'Reversed' ? '#cf1322' : '#595959'
                            ),
                            background: (
                              record.status === 'Cleared' ? 'rgba(82,196,26,0.15)' :
                                record.status === 'Confirmed' ? 'rgba(22,119,255,0.15)' :
                                  record.status === 'Reversed' ? 'rgba(255,77,79,0.12)' : 'rgba(0,0,0,0.06)'
                            ),
                            minWidth: 88,
                            textAlign: 'center'
                          }}
                        >
                          {translateStatus(record.status)}
                        </span>
                      </TableCell>
                      <TableCell align="center">
                        <div onClick={(e) => e.stopPropagation()}>

                          {record.status === 'Draft' && (
                            <Tooltip className='tool-tip' title={intl.formatMessage({ id: 'settlement_ContinueAndConfirm' })}>
                              <Button size="small" type="primary" style={{ borderRadius: "12px" }} onClick={(e) => { e.stopPropagation(); setInitialDraft(record); setWizardVisible(true); }}>
                                {intl.formatMessage({ id: 'settlement_Continue' })}
                              </Button>
                            </Tooltip>
                          )}
                          {record.status === 'Confirmed' && (
                            <>
                              <Tooltip className='tool-tip' title={intl.formatMessage({ id: 'settlement_ClearSettlement' })}>
                                <Button
                                  size="small"
                                  onClick={(e) => { e.stopPropagation(); setClearModal({ visible: true, id }); }}
                                  style={{
                                    background: 'white',
                                    color: '#cf1322',
                                    border: '1px solid #ff7875',
                                    borderRadius: 12,
                                    padding: '0 10px',
                                    height: 24
                                  }}
                                >
                                  {intl.formatMessage({ id: 'settlement_Clear' })}
                                </Button>
                              </Tooltip>
                              <Tooltip className='tool-tip' title={intl.formatMessage({ id: 'settlement_ReverseSettlement' })}>
                                <Button
                                  size="small"

                                  onClick={(e) => { e.stopPropagation(); setReverseModal({ visible: true, id }); }}
                                  style={{
                                    background: 'white',
                                    color: '#595959',
                                    border: '1px solid #bfbfbf',
                                    borderRadius: 12,
                                    padding: '0 10px',
                                    height: 24
                                  }}
                                >
                                  {intl.formatMessage({ id: 'settlement_Reverse' })}
                                </Button>
                              </Tooltip>
                            </>
                          )}
                          {record.status === 'Cleared' && (
                            <Tooltip className='tool-tip' title={intl.formatMessage({ id: 'settlement_SettlementIsCleared' })}>
                              <Text type="secondary"
                                style={{
                                  marginTop: "-10px"
                                }}
                              >{intl.formatMessage({ id: 'settlement_Cleared' })}</Text>
                            </Tooltip>
                          )}

                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">{intl.formatMessage({ id: 'settlement_NoDataAvailable' }, { defaultMessage: 'No data available' })}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </MuiTable>
        </div>
      </div>

      {/* Wizard for new/continue */}
      <SettlementWizard
        visible={wizardVisible}
        onClose={() => { setWizardVisible(false); setInitialDraft(null); }}
        onSuccess={() => { fetchData(pagination.current, pagination.pageSize); }}
        initialData={initialDraft}
      />

      {/* View-only modal */}
      <SettlementViewModal
        visible={viewModal.visible}
        settlement={viewModal.record}
        onClose={() => setViewModal({ visible: false, record: null })}
      />

      {/* Clear Modal */}
      <Modal
        title={intl.formatMessage({ id: 'settlement_ClearSettlement' })}
        open={clearModal.visible}
        onCancel={() => setClearModal({ visible: false, id: null })}
        okText={intl.formatMessage({ id: 'settlement_MarkAsCleared' })}
        cancelText={intl.formatMessage({ id: 'cancel' })}
        onOk={() => clearForm.submit()}
        confirmLoading={loading}
        style={{ direction: isArabic ? 'rtl' : 'ltr' }}
      >
        <div style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
          <Form layout="vertical" form={clearForm} onFinish={async (values) => {
            try {
              setLoading(true);
              const payload = {
                bank_ref_no: values.bank_ref_no,
                bank_description: values.bank_description || intl.formatMessage({ id: 'settlement_NoDescriptionEntered' }),
                bank_transfer_date: values.bank_transfer_date?.format ? values.bank_transfer_date.format('YYYY-MM-DD') : values.bank_transfer_date
              };
              await settlementAPI.clear(clearModal.id, payload);
              message.success(intl.formatMessage({ id: 'settlement_MarkedAsCleared' }));
              setClearModal({ visible: false, id: null });
              clearForm.resetFields();
              fetchData(pagination.current, pagination.pageSize);
            } catch (e) {
              message.error(intl.formatMessage({ id: 'settlement_FailedToClear' }));
            } finally {
              setLoading(false);
            }
          }}>
            <Form.Item label={intl.formatMessage({ id: 'settlement_ACHReferenceNo' })} name="bank_ref_no" rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseEnterACHRef' }) }]}>
              <Input placeholder={intl.formatMessage({ id: 'settlement_EnterBankRefNumber' })} />
            </Form.Item>
            <Form.Item label={intl.formatMessage({ id: 'settlement_Description' })} name="bank_description" initialValue={intl.formatMessage({ id: 'settlement_NoDescriptionEntered' })} rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseEnterDescription' }) }]}>
              <Input placeholder={intl.formatMessage({ id: 'settlement_DescriptionPlaceholder' })} />
            </Form.Item>
            <Form.Item
              label={intl.formatMessage({ id: 'settlement_TransferDate' })}
              name="bank_transfer_date"
              initialValue={moment()}
              rules={[
                { required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectTransferDate' }) },
                {
                  validator: (_, value) => {
                    if (value && moment(value).isAfter(moment(), 'day')) {
                      return Promise.reject(new Error(intl.formatMessage({ id: 'settlement_TransferDateCannotBeFuture' })));
                    }
                    return Promise.resolve();
                  }
                }
              ]}
            >
              <DatePicker
                variant="inline"
                inputVariant="outlined"
                format="DD-MM-yyyy"
                style={{ width: '100%', height: '28px' }}
                InputProps={{ style: { height: '28px' } }}
                maxDate={moment()}
                value={clearForm.getFieldValue('bank_transfer_date') || moment()}
                onChange={(date) => {
                  clearForm.setFieldsValue({ bank_transfer_date: date });
                  // Trigger validation after setting the value
                  clearForm.validateFields(['bank_transfer_date']);
                }}
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>

      {/* Reverse Modal */}
      <Modal
        title={intl.formatMessage({ id: 'settlement_ReverseSettlement' })}
        open={reverseModal.visible}
        onCancel={() => setReverseModal({ visible: false, id: null })}
        okText={intl.formatMessage({ id: 'settlement_Reverse' })}
        cancelText={intl.formatMessage({ id: 'cancel' })}
        onOk={() => reverseForm.submit()}
        confirmLoading={loading}
        style={{ direction: isArabic ? 'rtl' : 'ltr' }}
      >
        <div style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
          <Form layout="vertical" form={reverseForm} onFinish={async (values) => {
            try {
              setLoading(true);
              const payload = { reversal_reason: values.reversal_reason };
              await settlementAPI.reverse(reverseModal.id, payload);
              message.success(intl.formatMessage({ id: 'settlement_ReversedSuccessfully' }));
              setReverseModal({ visible: false, id: null });
              reverseForm.resetFields();
              fetchData(pagination.current, pagination.pageSize);
            } catch (e) {
              message.error(intl.formatMessage({ id: 'settlement_FailedToReverse' }));
            } finally {
              setLoading(false);
            }
          }}>
            <Form.Item label={intl.formatMessage({ id: 'settlement_ReversalReason' })} name="reversal_reason" rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseEnterReversalReason' }) }]}>
              <Input.TextArea rows={3} placeholder={intl.formatMessage({ id: 'settlement_EnterReasonForReversal' })} />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  );
};

export default SettlementsTable;
